const VerificationValidationMessages = {
  english: {
    custom: {
      verificationCode: {
        required: 'Please enter a valid code',
        verification: 'Incorrect code entered'
      }
    }
  }
};

export default VerificationValidationMessages;
